import api, { ApiResponse } from './api';

export interface Department {
  id: number;
  departmentId: number;
  name: string;
  departmentName: string;
  description?: string;
  managerId?: number;
  managerName?: string;
  siteId?: number | null;
  locationId?: number | null;
  mealCateringCompanyId?: number | null;
  employeeCount: number;
  isActive: boolean;
}

export interface DepartmentCreateDto {
  name: string;
  description?: string;
  managerId?: number;
  siteId?: number | null;
  locationId?: number | null;
  mealCateringCompanyId?: number | null;
}

export interface DepartmentUpdateDto {
  name?: string;
  description?: string;
  managerId?: number;
  siteId?: number | null;
  locationId?: number | null;
  mealCateringCompanyId?: number | null;
  isActive?: boolean;
}

const departmentService = {
  getAll: async (): Promise<ApiResponse<Department[]>> => {
    return api.get('/departments');
  },

  getById: async (id: number): Promise<ApiResponse<Department>> => {
    return api.get(`/departments/${id}`);
  },

  create: async (data: DepartmentCreateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.post('/departments', data);
  },

  update: async (id: number, data: DepartmentUpdateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.put(`/departments/${id}`, data);
  },

  delete: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.delete(`/departments/${id}`);
  },
};

export default departmentService;
